import type { FormListFilter, FormListItem, FormsHeaderStats } from './types';

export function formsHeaderStats(forms: FormListItem[]): FormsHeaderStats {
  return {
    total: forms.length,
    published: forms.filter((f) => f.status === 'published').length,
    drafts: forms.filter((f) => f.status === 'draft').length,
    compliance: forms.filter((f) => f.compliance).length,
  };
}

export function filterFormsList(
  forms: FormListItem[],
  filter: FormListFilter,
  search: string,
): FormListItem[] {
  return forms
    .filter((form) => {
      if (filter === 'active') return form.status === 'published';
      if (filter === 'drafts') return form.status === 'draft';
      if (filter === 'archived') return form.status === 'archived';
      if (filter === 'compliance') return form.compliance;
      return true;
    })
    .filter(
      (form) =>
        !search ||
        form.name.toLowerCase().includes(search.toLowerCase()) ||
        form.desc.toLowerCase().includes(search.toLowerCase()),
    );
}

export function formsFilterCounts(forms: FormListItem[]) {
  return {
    all: forms.length,
    active: forms.filter((f) => f.status === 'published').length,
    drafts: forms.filter((f) => f.status === 'draft').length,
    archived: forms.filter((f) => f.status === 'archived').length,
    compliance: forms.filter((f) => f.compliance).length,
  };
}

export function completionTone(completion: number): 'success' | 'gold' | 'warning' {
  if (completion >= 80) return 'success';
  if (completion >= 50) return 'gold';
  return 'warning';
}

export function completionColor(completion: number): string {
  const tone = completionTone(completion);
  if (tone === 'success') return 'var(--success)';
  if (tone === 'gold') return 'var(--gold)';
  return 'var(--terracotta)';
}

export function formatRelativeSavedAgo(savedAt: Date, nowMs = Date.now()): string {
  const sec = Math.floor((nowMs - savedAt.getTime()) / 1000);
  if (sec < 10) return 'just now';
  if (sec < 60) return `${sec}s ago`;
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}m ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const days = Math.floor(hr / 24);
  return `${days}d ago`;
}
